<template>
  <div>
    <div class="jumbotron jumbotron-fluid section-header">
      <div class="container">
        <h1 class="display-4">ByteArk ISP SPEED INDEX</h1>
        <p class="lead">ByteArk ISP Speed Index เกิดจากการวัดความเร็วในการส่งข้อมูลจากระบบ CDN ของ ByteArk ให้ผู้ใช้งานอินเทอร์เน็ตทั่วไป</p>
<!--         <router-link :to="'about'" class="btn btn-outline-light">
          ByteArk คำนวน ISP SPEED INDEX อย่างไร ?
        </router-link> -->
      </div>
    </div>
    <DailyLeaderBoard />
    <div class="section section-calculate">
      <div class="container">
        <router-link :to="'about'">
          <h4 class="title">ByteArk คำนวน ISP SPEED INDEX อย่างไร ?</h4>
        </router-link>
      </div>
    </div>

    <div class="section section-aboutus">
      <div class="container">
        <h4 class="title">รู้จักเกี่ยวกับ BYTEARK</h4>
        <div class="line"></div>
        <p class="content">ByteArk คือผู้ให้บริการ CDN ชั้นนำของประเทศไทย ให้บริการการเผยแพร่ไฟล์ วิดีโอและไลฟ์สตรีมมิ่ง และระบบที่เกี่ยวข้องอย่างครบวงจร เพื่อตอบโจทย์ธุรกิจของผู้ให้บริการสื่อ เว็บไซต์ และแอปพลิเคชันต่างๆ ตลอดจนตอบโจทย์นักพัฒนาในการเชื่อมต่อกับระบบของนักพัฒนาเอง</p>
      </div>
    </div>

<!--     <div class="section social-share">
      <div class="container">
        <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button&size=large&mobile_iframe=true&appId=1266895469994687&width=65&height=28" width="65" height="28" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
      </div>
    </div> -->
  </div>
</template>

<script>
import DailyLeaderBoard from '@/components/parts/DailyLeaderBoard';

export default {
  name: 'home',
  components: {
    DailyLeaderBoard,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';


.section-header {
  // background-image: url('https://www.byteark.com/wp-content/uploads/2013/06/map_circle.png');
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%2303a9f4' fill-opacity='0.2' fill-rule='evenodd'/%3E%3C/svg%3E"),linear-gradient(to bottom, #03a9f4, #0092d5);
  // background-position: right center;
  // background-repeat: no-repeat;
  background-color:rgba(0,166,237, 1);
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue